import React, { Dispatch, SetStateAction, useEffect, useState } from "react";

import { Attribute, AttributeData_String, Maybe, MdmDeviceDto, MdmObjectDto } from "gql/generated/types";
import { Accordion, AccordionTab } from "primereact/accordion";
import InputLabelWrapper from "components/basic/input-label-wrapper/InputLabelWrapper";
import { InputText } from "primereact/inputtext";

type AdditionalInfoProps<T> = {
  attributes: (Attribute | null)[];
  objectState: T;
  setObjectState: Dispatch<SetStateAction<T>>
  editable?: boolean;
};
const AdditionalInfo = <T extends MdmObjectDto | MdmDeviceDto>({
  attributes,
  objectState,
  setObjectState,
  editable
}: AdditionalInfoProps<T>) => {
  const map = new Map(objectState.customFields?.map(field => [field?.key, field?.value]));
  const [attributeMap, setAttributeMap] = useState<Map<Maybe<string> | undefined, Maybe<AttributeData_String> | undefined>>(map);

  useEffect(() => {
    setObjectState(prev => ({
      ...prev,
      customFields: [...attributeMap].map(([key, value]) => ({
        key,
        value,
      })),
    }));
  }, [attributeMap]);

  const attributeGroups = attributes.reduce((acc, curr) => {
    const parent = curr?.parent?.toString();
    if (!parent || !curr) return acc;
    const parentAttributes = acc.get(parent);
    if (!parentAttributes) return acc.set(parent, [curr]);
    return acc.set(parent, [...parentAttributes, curr]);
  }, new Map<string, Attribute[]>());

  const nodes = [...attributeGroups].map(([key, value]) => (
    <AccordionTab key={key} header={key}>
      <div className="grid">
        {value.map((attr: Attribute) => (
          <InputLabelWrapper key={attr.id} labelName={attr.title} col={2}>
            <InputText
              value={attributeMap.get(attr.id)?.value!}
              onChange={e =>
                setAttributeMap(
                  prev => new Map(prev.set(attr.id, { type: attr.type, value: e.target.value }))
                )
              }
              className="p-inputtext-sm"
              name={attr.title}
              disabled={!editable}
            />
          </InputLabelWrapper>
        ))}
      </div>
    </AccordionTab>
  ));

  return <Accordion className="w-full mt-3">{nodes}</Accordion>;
};

export default AdditionalInfo;